import { render, staticRenderFns } from "./staffForm.vue?vue&type=template&id=16c5a3dd&"
import script from "./staffForm.vue?vue&type=script&lang=js&"
export * from "./staffForm.vue?vue&type=script&lang=js&"
import style0 from "./staffForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports